<template>
  <div class="container my-4">
    <div class="component-header mb-4">
      <h1>Osoba</h1>
      <div class="ml-4 add-edit-actions">
        <button type="submit" form="people-details" class="action">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
        <button data-toggle="modal" data-target="#people" class="action">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div
        class="saved-text"
        v-bind:class="[showMessage ? 'visible' : 'hidden', success ? 'text-success' : 'text-danger']"
      >
        {{ messageText }}
      </div>
    </div>
    <form id="people-details" @submit.prevent="save">
      <div class="form-group">
        <label for="name">Imię*</label>
        <input
          type="text"
          class="form-control"
          id="name"
          v-model="person.name"
          required
          maxlength="50"
        />
        <small class="form-text text-muted">Pole obowiązkowe</small>
      </div>
      <div class="form-group">
        <label for="lastName" required>Nazwisko*</label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          v-model="person.lastName"
          required
          maxlength="150"
        />
        <small class="form-text text-muted">Pole obowiązkowe</small>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="personcontentPL">Opis w języku polskim</label>
          <div>
            <vue-editor
              id="personcontentPL"
              v-model="person.contentPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="personContentDE">Opis w języku niemieckim</label>
          <div>
            <vue-editor
              v-model="person.contentDE"
              id="personcontentDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>
      <div class="form-group" v-bind:class="[id ? 'visible' : 'hidden']">
        <button @click="editImages" type="button" class="btn btn-primary btn-lg btn-block">
          Zdjęcia
        </button>
      </div>
    </form>
    <Modal v-bind:settings="modalSettings" @confirm="goBack()" />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Modal from "./Modal";
import PeopleImage from "./Image";
import VueUploadMultipleImage from "vue-upload-multiple-image";
export default {
  components: {
    VueEditor,
    Modal
  },
  props: ["list"],
  data() {
    return {
      person: {
        images: []
      },
      content: "",
      modalSettings: {
        body: "Czy na pewno chcesz wyjść? Niezapisane zmiany zostaną utracone.",
        modalId: "people",
      },
      messageText: "",
      showMessage: false,
      id: null,
      controlImages: [],
      success: false
    };
  },
  methods: {
    initialize: function () {
      this.id = this.$route.params.id;
      if (this.id) {
        this.$api.getPersonById(this.id).then((data) => {
          this.person = data;
        });
      }
    },
    editImages: function () {
      this.$router.push({
        name: "PeopleImagesEdit",
        params: { id: this.id },
      });
    },
    addImage: function () {
      let maxId =
        this.person.images && this.person.images.length
          ? this.person.images.reduce(
              (max, image) => (image.id > max ? image.id : max),
              this.person.images[0].id
            )
          : 0;
      let image = {
        descriptionPL: "",
        descriptionDE: "",
        id: maxId + 1,
        name: "",
        imageData: null
      };
      this.person.images.push(image);
      return image;
    },
    uploadImageSuccess(formData, index, fileList) {
      let image = this.addImage();
      image.imageData = fileList[index].path;
      image.name = fileList[index].name;
      if (index === fileList.length - 1) {
        this.controlImages.splice(0);
      }
    },
    removeImage(image) {
      var index = this.person.images.indexOf(image);
      if (index > -1) {
        this.person.images.splice(index, 1);
      }
    },
    save: function () {
      let slug = this.getSlug(this.person.name, this.person.lastName);
      if (this.list && this.list.length) {
        var buildingExists = this.list
          .filter((b) => b.id != this.id)
          .some((b) => b.slug == slug);
        if (buildingExists) {
          this.displayNonUniqueValue();
          return;
        }
      }
      this.person.slug = slug;
      if (this.id) {
        this.update(this.person);
      } else {
        this.create(this.person);
      }
    },
    update: function (data) {
      this.$api.updatePerson(data).then((data) => {
        if (data.ok) {
          this.displaySucess();
        } else {
          this.displayFailure();
        }
      });
    },
    create: function (data) {
      this.$api.createPerson(data).then((data) => {
        if (data.ok) {
          this.displaySucess();
          this.goBack();
        } else {
          this.displayFailure();
        }
      });
    },
    getSlug(name, lastName) {
      let slug = "";
      if (lastName) {
        slug =
          slug +
          this.$localization
            .normalizeString(lastName.toLowerCase())
            .trim()
            .replace(/\s+/g, "-");
      }
      if (name) {
        slug =
          slug +
          "-" +
          this.$localization
            .normalizeString(name.toLowerCase())
            .trim()
            .replace(/\s+/g, "-");
      }
      return slug;
    },
    displaySucess: function () {
      this.messageText = "Dane zostały pomyślnie zapisane";
      this.showMessage = true;
      this.success = true;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayFailure: function () {
      this.messageText = "Wystąpił błąd w zapisie danych";
      this.showMessage = true;
      this.success = false;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayNonUniqueValue: function () {
      this.messageText =
        "Nie można zapisać osoby. Osoba o tym samym imieniu i nazwisku istnieje.";
      this.showMessage = true;
      this.success = false;
    },
    goBack() {
      this.$router.push({ name: "People" });
    },
    goBackWithSave() {
      this.save();
      this.goBack();
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize();
    next();
  },
};
</script>

<style>
#personcontentDE,
#personcontentPL {
  height: 450px;
}
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>